const api = {
  purchaser: {
    // 新建详情接口
    getPurTempFieldDetails: {
      url: '/purchaser/mall/purCategorySubmitTemp/getTempDetailsByParam',
      type: 'post'
    },
    // 编辑详情接口
    getPurTempFieldEditDetails: {
      url: '/purchaser/mall/purSubmitBizData/getBizDataDetails',
      type: 'post'
    },
    // 模板字段提交
    saveBizData: {
      url: '/purchaser/mall/purSubmitBizData/saveBizData',
      type: 'post'
    }
  },
  mall: {
    // 新建详情接口
    getPurTempFieldDetails: {
      url: '/mall/purCategorySubmitTemp/getTempDetailsByParam',
      type: 'post'
    },
    // 编辑详情接口
    getPurTempFieldEditDetails: {
      url: '/mall/purSubmitBizData/getBizDataDetails',
      type: 'post'
    },
    // 模板字段提交
    saveBizData: {
      url: '/mall/purSubmitBizData/saveBizData',
      type: 'post'
    }
  },
  supplier: {
    
  }
}
export default api[window.fe.project]
